import React from "react";
import InlineSVG from "react-inlinesvg";
import { ProsePreferencesCardContainer } from "./styles.js";
import { sendAppEvent } from "../../../Utils.js";

export default function ProsePreferencesCard({ onClose }) {
  return (
    <ProsePreferencesCardContainer>
      <InlineSVG
        src="/assets/close.svg"
        className="close"
        onClick={(event) => {
          event.stopPropagation();
          onClose();
        }}
      />
      <div className="prose-title">Want to improve Sudowrite's prose style?</div>
      <a
        className="yes-button"
        target="_blank"
        rel="noopener noreferrer"
        href="https://prose-preferences-qjr0.onrender.com"
        onClick={(e) => {
          e.preventDefault();
          sendAppEvent("Click Prose Preferences", { source: "promo_card" });
          window.open("https://prose-preferences-qjr0.onrender.com", "_blank");
        }}
      >
        Yes!
      </a>
    </ProsePreferencesCardContainer>
  );
}
